<template>
  <div class="feedback-placeholder">
    <!-- 这个页面现在只是一个占位符，逻辑已移至全局弹窗 -->
  </div>
</template>

<script>
export default {
  mounted() {
    // 当直接访问 /feedback 路由时，触发全局弹窗并返回首页
    this.$bus.$emit('showFeedback');
    this.$router.replace('/');
  }
}
</script>

<style scoped>
.feedback-placeholder {
  min-height: 60vh;
}
</style>
